import { useState } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import api from '../../api/endpoints';
import PageHeader from '../../components/PageHeader';
import { Button, Input } from '../../components/Ui';
import { Reveal, Pop } from '../../components/Motion';
import { useToast } from '../../context/ToastContext';
import { colors } from '../../theme';

const LABELS = ['', 'Poor', 'Fair', 'Good', 'Very good', 'Excellent'];

const WriteReviewPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const toast = useToast();

  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [saving, setSaving] = useState(false);

  if (!state || !state.targetType) return <Navigate to="/activity" replace />;

  const {
    targetType, target, order, booking, title,
  } = state;

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.reviews.create({
        targetType, target, rating, comment, order, booking,
      });
      toast.success('Your review helps other customers choose the right partner.', 'Thank you!');
      navigate(-1);
    } catch (err) {
      toast.error(err.message, 'Could not submit');
    } finally {
      setSaving(false);
    }
  };

  const shown = hover || rating;

  return (
    <div style={{ maxWidth: 560 }}>
      <PageHeader title="Write a review" subtitle={title} />

      <form onSubmit={submit}>
        <Reveal className="card sh-sm" style={{ textAlign: 'center' }}>
          <h3 className="h3">How was your experience?</h3>
          <div className="row" style={{ justifyContent: 'center', gap: 6, margin: '16px 0 6px' }}>
            {[1, 2, 3, 4, 5].map((n) => (
              <button
                key={n}
                type="button"
                onClick={() => setRating(n)}
                onMouseEnter={() => setHover(n)}
                onMouseLeave={() => setHover(0)}
                aria-label={`${n} star${n > 1 ? 's' : ''}`}
                className="press"
                style={{
                  background: 'none', border: 0, fontSize: 38, lineHeight: 1,
                  color: n <= shown ? colors.star : colors.line,
                  transition: 'color .14s ease, transform .14s ease',
                  transform: n <= shown ? 'scale(1.06)' : 'none',
                }}
              >
                ★
              </button>
            ))}
          </div>
          <Pop key={shown}>
            <div className="t-title" style={{ color: colors.primary }}>{LABELS[shown]}</div>
          </Pop>
        </Reveal>

        <Input
          label="Tell others about it (optional)"
          textarea
          rows={5}
          placeholder="What went well? What could be better?"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          style={{ marginTop: 20 }}
        />

        <Button title="Submit review" type="submit" loading={saving} size="lg" full />
      </form>
    </div>
  );
};

export default WriteReviewPage;
